"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actionMenuTypes = _interopRequireDefault(require("./action-menu-types"));

var _default = {
  [_actionMenuTypes.default.REPLACE]: 'Replace',
  [_actionMenuTypes.default.CROP]: 'Crop',
  [_actionMenuTypes.default.EDIT]: 'Edit video',
  [_actionMenuTypes.default.DELETE]: 'Delete',
  [_actionMenuTypes.default.LOGOUT]: 'Disconnect',
  [_actionMenuTypes.default.SUPPORT]: 'Get Support',
  [_actionMenuTypes.default.FAQ]: 'FAQ',
  [_actionMenuTypes.default.DUPLICATE]: 'Duplicate',
  [_actionMenuTypes.default.REMOVE_BG]: 'Remove bg',
  [_actionMenuTypes.default.BILLING]: 'Billing'
};
exports.default = _default;